export const IconBellNotification: {
  name: 'icon_bell_notification-ea1ce182f203'
} = {
  name: 'icon_bell_notification-ea1ce182f203'
}
